import type { SubscribeToExtendedPage_extendedPage_customCss } from "../../../../../../../api/__generated__/SubscribeToExtendedPage";

type SelectedTextPosition = { start: number; size: number };

function selectedClasses(
  selection: SelectedTextPosition,
  metadata: SubscribeToExtendedPage_extendedPage_customCss[],
) {
  const end = selection.start + selection.size;
  const ranges: { start: number; end: number; value: string }[] = [];
  for (const item of metadata) {
    // CSS rendering currently uses the first anchor of each metadata item.
    const anchor = item.anchors[0];
    if (!anchor) continue;
    const start = Math.max(selection.start, anchor.utf16Start);
    const rangeEnd = Math.min(end, anchor.utf16Start + anchor.utf16Size);
    if (start < rangeEnd) {
      ranges.push({ start, end: rangeEnd, value: item.data.customCssClasses || "" });
    }
  }
  const boundaries = [
    ...new Set([selection.start, end, ...ranges.flatMap((range) => [range.start, range.end])]),
  ].sort((a, b) => a - b);
  // Match the renderer's first-annotation precedence, including unannotated gaps.
  return new Set(
    boundaries
      .slice(0, -1)
      .map(
        (start) => ranges.find((range) => range.start <= start && start < range.end)?.value || "",
      ),
  );
}

export const hasDifferentClasses = (
  selection: SelectedTextPosition,
  metadata: SubscribeToExtendedPage_extendedPage_customCss[],
) => selectedClasses(selection, metadata).size > 1;

export const getCommonClass = (
  selection: SelectedTextPosition,
  metadata: SubscribeToExtendedPage_extendedPage_customCss[] = [],
) => {
  const classes = selectedClasses(selection, metadata);
  return classes.size === 1 ? classes.values().next().value || "" : "";
};
